import { CustomStyleOverrideProps } from './types'

export const getBrandPrimaryColor = (
  props?: Partial<CustomStyleOverrideProps>
) => {
  if (props?.brandColor) return props.brandColor
  return 'var(--brand-primary)'
}

export const getDangerColor = (props?: Partial<CustomStyleOverrideProps>) => {
  if (props?.dangerColor) return props.dangerColor
  return 'var(--danger)'
}

export const getBorderColor = (props?: Partial<CustomStyleOverrideProps>) => {
  if (props?.borderColor) return props.borderColor
  return 'var(--gray200)'
}

export const getBorderRadius = (props?: Partial<CustomStyleOverrideProps>) => {
  if (props?.borderRadius) return props.borderRadius
  return 'var(--border-radius-sm)'
}

export const getTextPrimaryColor = (
  props?: Partial<CustomStyleOverrideProps>
) => {
  if (props?.textPrimaryColor) return props.textPrimaryColor
  return 'var(--text-primary)'
}

export const getTextSecondaryColor = (
  props?: Partial<CustomStyleOverrideProps>
) => {
  if (props?.textSecondaryColor) return props.textSecondaryColor
  return 'var(--text-secondary)'
}
